var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-office-pdf"},[_c('div',{ref:"rootRef",staticClass:"vue-office-pdf-main",attrs:{"id":"vue-office-pdf-main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }